import React, { useMemo } from "react";
import PowerBi from "@pages/PowerBi";
import PageHeader from "@features/shared/components/PageHeader";

/**
 * TSIMarketWorking Component
 * Displays TSI Market Working FTD Power BI dashboard
 * Optimized with React.memo and useMemo
 */
const TSIMarketWorking = () => {
  // Memoized page configuration
  const pageName = useMemo(
    () => ({
      id: "fea60e84-eaf3-48a4-90ad-795360fb0878",
      name: "TSI Market Working - FTD",
    }),
    []
  );

  return (
    <>
      <PageHeader title="TSI Market Working FTD" path="/" />
      <div className="p-2">
        <PowerBi
          id="ba696416-1e37-40f8-854e-c6816ef9104c"
          pageName={pageName}
          filterName="DimHierarchy"
          height="80vh"
        />
      </div>
    </>
  );
};

export default React.memo(TSIMarketWorking);